"use client";

import Link from "next/link";

import { cn } from "@/lib/utils";
import React from "react";
import { Icons } from "@/components/icons";
import { type } from "os";

export const menus = [
  {
    name: "Semua Event",
    path: "/events/all" as const,
    icon: <Icons.allEventsNew className="w-4 h-4" />,
  },
  {
    name: "Event Pilihan",
    path: "/events/featured" as const,
    icon: <Icons.star className="w-4 h-4" />,
  },
  {
    name: "Event Berlangsung",
    path: "/events/ongoing" as const,
    icon: <Icons.calendar className="w-4 h-4" />,
  },
  {
    name: "Event Berlalu",
    path: "/events/past" as const,
    icon: <Icons.clockRounded className="w-4 h-4" />,
  },
  {
    name: "Event Selanjutnya",
    path: "/events/upcoming" as const,
    icon: <Icons.ticket className="w-4 h-4" />,
  },
];

export function EventTypeMenuTitle({ type }: { type: string }) {
  return (
    <h1 className="text-2xl font-extrabold capitalize xl:text-3xl dark:text-[#0D0D0D]">
      {menus.find((menu) => menu.path === `/events/${type}`)?.name ?? ""}
    </h1>
  );
}

export function EventTypeSelector({
  menu,
  params,
}: {
  menu: (typeof menus)[number];
  params: { type: string };
}) {
  const isActive = "/events/" + params.type === menu.path;

  return (
    <Link
      href={menu.path}
      className={cn(
        "flex flex-col items-center justify-center h-20 lg:h-24 px-4 rounded-md bg-theme-black2 dark:bg-[#DFE3E8] hover:bg-opacity-50 whitespace-nowrap space-y-2.5 transition-colors duration-300",
        {
          "col-span-2": menu.path === "/events/upcoming",
          "bg-theme-accent dark:bg-theme-accent": isActive,
        }
      )}
    >
      {React.cloneElement(menu.icon, {
        className: cn("w-4 h-4 transition-colors duration-300", {
          "text-white": isActive,
          "text-theme-accent": !isActive,
        }),
      })}
      <span
        className={cn(
          "text-sm font-medium xl:text-base transition-colors duration-300",
          {
            "text-white dark:text-white": isActive,
            "text-white dark:text-theme-black3": !isActive,
          }
        )}
      >
        {menu.name}
      </span>
    </Link>
  );
}

export function Menu({ params }: { params: { type: string } }) {
  return (
    <>
      {menus.map((menu) => (
        <EventTypeSelector key={menu.name} menu={menu} params={params} />
      ))}
    </>
  );
}
